<template>
  <Card>
    <Button type="primary" class="public-fr" icon="ios-undo" @click="back"
      >返回</Button
    >
    <table style="margin-top: 40px">
      <tr>
        <th colspan="7">物料信息</th>
      </tr>
      <tr>
        <th>物料名称</th>
        <td>{{ detail.name }}</td>
        <th>渠道编码</th>
        <td>{{ detail.channelCode }}</td>
        <th>品牌编号</th>
        <td>{{ detail.brandCode }}</td>
      </tr>
      <tr>
        <th>批次号</th>
        <td>{{ detail.batchNumber }}</td>
        <th>物料类型</th>
        <td>{{ detail.materialTypeCode }}</td>
        <th>物料别名</th>
        <td>{{ detail.nickName }}</td>
      </tr>
      <tr>
        <th>二维码基础编码</th>
        <td>{{ detail.qrBaseCode }}</td>
        <th>二维码尺寸</th>
        <td>{{ detail.qrSize }}</td>
        <th>物料简称</th>
        <td>{{ detail.shortName }}</td>
      </tr>
      <tr>
        <th>补发数量</th>
        <td>{{ detail.resendNum }}</td>
        <th>下发数量</th>
        <td>{{ detail.sendNum }}</td>
        <th>备注</th>
        <td>{{ detail.remark }}</td>
      </tr>
      <tr>
        <th>生效日期</th>
        <td>{{ detail.startDate }}</td>
        <th>失效日期</th>
        <td>{{ detail.endDate }}</td>
        <th>状态</th>
        <td>{{ detail.status }}</td>
      </tr>
      <tr>
        <th>添加时间</th>
        <td>{{ detail.addTime }}</td>
        <th>添加人</th>
        <td>{{ detail.addUserId }}</td>
        <th>物料设计图</th>
        <td>
          <Avatar
            shape="square"
            size="large"
            :src="detail.designImage"
            class="img_icon"
          />
        </td>
      </tr>
    </table>
  </Card>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      let data = this.$route.query;
      this.$api.materManDetail(data).then((res) => {
        if (res.code == "200") {
          this.detail = res.data;
        }
      });
    },
    back() {
      this.$router.push({
        path: "list",
      });
    },
  },
};
</script>
<style scoped>
table {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
}

th,
td {
  padding: 0 10px;
  text-align: center;
  border: 1px solid #dcdee2;
  line-height: 30px;
  color: #515a6e;
  font-size: 12px;
}

th {
  background: #f8f8f9;
}
.img_icon {
  margin: 10px;
}
</style>





// WEBPACK FOOTER //
// src/views/material/materDetial.vue